import React, { useMemo, useState } from "react";
import moment from "moment";
import { useEffect } from "react";
import axios from "axios";
import { Button, Label } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useParams, Link, useNavigate } from "react-router-dom";
import { environment } from "../../../../env";
import "../../../../components/BuildingViewCard/BuildingDropDown.css";
import Table from "../../../../components/Table";
import DocumentsCard from "../../../../components/DocumentsCard/DocumentsCard";
import EmptyDoc from "../../../../components/errorComponents/EmptyDoc";
import PriceFormater from "../../../../Helper/PriceFormater";
import BuildingExcelTable from "../../../../components/Tables/BuildingExcelTable";
import PathName from "../../../../components/PathName/PathName";
import WarningPopup from "../../../../components/Popups/WarningPopup";
import { warningModalToggle } from "../../../../redux/actions/Index";
import { ToastContainer, toast } from 'react-toastify';

function TenantGalasView() {
  const [galatenant, setGalaTenant] = useState();
  const [pocData, setPocData] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [proposalinvestors, setProposalInvestors] = useState();
  const [sortGala, setSortGala] = useState([]);
  const [tenantdoc, setTenantdoc] = useState();
  const [arry, setArry] = useState([]);
  const [togUploadedDocs, setTogUploadedDocs] = useState(false);
  const [annualRentTableToggle, setAnnualRentTableToggle] = useState(false);
  const [exactObject, setExactObject] = useState();
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const navigate = useNavigate();
  const { id } = useParams();

  const dispatch = useDispatch()

  const columnnn = [
    {
      name: "Investor",
      selector: (row) => row?.investor_name,
      sortable: true,
      wrap: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Building Number",
      selector: (row) => row?.building_name,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Gala No",
      selector: (row) => Number(row.gala_no),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Area Owns",
      selector: (row) => row.area_own + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Rented Area",
      selector: (row) => row?.rent_area + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
  ];

  const getInvestorGalaSort = () => {
    const tableArr = [];
    proposalinvestors?.map((data, index) => {
      tableArr.push({
        id: index + 1,
        investor_name: data.investor.Investors?.name,
        building_name: data.investor?.building?.building_no,
        gala_no: data.investor.gala.gala_no,
        sub_gala_name: data.investor.sub_gala_name,
        area_own: data.investor.sold_gala_area,
        rent_area: data.required_area,
      });
    });
    setSortGala(tableArr);
  };

  const viewGalaTenant = () => {
    axios
      .get(`${environment.baseUrl}edit-gala-tenant/${id}`)
      .then((res) => {
        setGalaTenant(res.data);
        getProposalInvestors(res.data.proposal.id);
        getTenantDocs(res.data.id);
      })
      .catch((res) => {
        console.log("errorss");
      });
  };

  const getTenantDocs = async (data) => {
    try {
      await axios
        .get(`${environment.baseUrl}upload-tenant-doc/`)
        .then((doc) => {
          let dat = doc.data.filter((curElm) => curElm.galatenant == data && curElm.view == 0);
          setTenantdoc(dat);
        });
    } catch (err) {
      console.log(err);
    }
  }

  const getProposalInvestors = async (data) => {
    if (data) {
      try {
        await axios
          .get(`${environment.baseUrl}proposal-investors/${data}`)
          .then((proposal) => {
            setProposalInvestors(proposal.data);
          });
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getPocList = () => {
    axios
      .get(`${environment.baseUrl}tenant-poc/${id}`)
      .then((res) => {
        setPocData(res.data);
      })
      .catch((res) => {
        console.log("errorss");
      });
  };

  const getTenant = () => {
    try {
      axios
        .get(`${environment.baseUrl}tenant-rentannual/${id}`)
        .then((res) => {
          res.data.map((data, i) => {
            data.srno = i + 1;
          });
          setArry(res.data);
        })
        .catch((res) => {
          setAnnualrent([]);
          console.log("error");
        });
    } catch (err) {
      console.log(err);
    }
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.poc_name,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Contact No",
      selector: (row) => row.poc_contact_number ?? "-",
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Email",
      selector: (row) => row.poc_email,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Designation",
      selector: (row) => row.poc_desigation,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Comment",
      selector: (row) => row.poc_comment,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
  ];
  const colums = [
    {
      name: "Sr No",
      selector: (row) => row?.srno,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Start Date",
      selector: (row) => moment(row?.start_date).format("DD-MM-YYYY"),
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "End Data",
      selector: (row) => moment(row?.end_date).format("DD-MM-YYYY"),
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Rent ₹",
      selector: (row) => <PriceFormater price={row.rent} />,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Inc %",
      selector: (row) => `${row?.rent_increment} %`,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Inc ₹",
      selector: (row) => <PriceFormater price={row.rent_incrementamt} />,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Rent/M",
      selector: (row) => (
        <PriceFormater
          price={row?.rent * Number(galatenant?.proposal?.required_area)}
        />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
  ];

  const maintenanceVaraiColumn = [
    {
      name: "Sr No",
      selector: (row) => row?.srno,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Start Date",
      selector: (row) => moment(row?.start_date).format("DD-MM-YYYY"),
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "End Data",
      selector: (row) => moment(row?.end_date).format("DD-MM-YYYY"),
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Maintance/Sqft",
      selector: (row) => (
        <PriceFormater price={Number(row?.maintenance)} />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Inc %",
      selector: (row) => (
        `${row?.maintenance_increment}%`
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Inc ₹",
      selector: (row) => (
        <PriceFormater price={Number(row?.maintenance_incrementamt)} />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Maintance/M",
      selector: (row) => (
        <PriceFormater
          price={
            Number(row?.maintenance) *
            Number(galatenant?.proposal?.required_area)
          }
        />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Varai/Sq ft",
      selector: (row) => (
        <PriceFormater price={Number(row?.varai)} />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Inc %",
      selector: (row) => `${row?.varai_increment} %`,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Inc ₹",
      selector: (row) => (
        <PriceFormater price={Number(row?.varai_incrementamt)} />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Varai/M",
      selector: (row) => (
        <PriceFormater
          price={
            Number(row?.varai) *
            Number(galatenant?.proposal?.required_area)
          }
        />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
  ];

  const extraOtherColumn = [
    {
      name: "Sr No",
      selector: (row) => row?.srno,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Start Date",
      selector: (row) => moment(row?.start_date).format("DD-MM-YYYY"),
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "End Data",
      selector: (row) => moment(row?.end_date).format("DD-MM-YYYY"),
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Extra Amenities ₹",
      selector: (row) => <PriceFormater price={row.extra_amenities} />,
      sortable: true,
      style: {
        fontSize: "2.6rem",
      },
    },
    {
      name: "Inc %",
      selector: (row) => `${row?.extra_amenities_increment} %`,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Inc ₹",
      selector: (row) => <PriceFormater price={row.extra_amenities_incrementamt} />,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "EA/M",
      selector: (row) => (
        <PriceFormater
          price={row?.extra_amenities * Number(galatenant?.proposal?.required_area)}
        />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Other Charges/Sq ft",
      selector: (row) => (
        <PriceFormater price={Number(row?.other_charges)} />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Inc %",
      selector: (row) => `${row?.other_charges_increment}%`,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Inc ₹",
      selector: (row) => (
        <PriceFormater price={Number(row?.other_charges_incrementamt)} />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "OC/M",
      selector: (row) => (
        <PriceFormater
          price={
            Number(row?.other_charges) *
            Number(galatenant?.proposal?.required_area)
          }
        />
      ),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      },
    },

  ];

  useEffect(() => {
    viewGalaTenant();
    getPocList();
    getTenant();
  }, []);

  useEffect(() => {
    if (proposalinvestors) {
      getInvestorGalaSort();
    }
  }, [proposalinvestors]);

  const deleteDocument = (id) => {
    dispatch(warningModalToggle(id));
  };

  const deleteDoc = (id) => {
    axios
      .put(`${environment.baseUrl}edit-tenant-doc/${id}`, { view: 1 })
      .then((res) => {
        if (res.data.code === 200) {
          dispatch(warningModalToggle(id));
          getTenantDocs();
          toast.success('Document Deleted Successfully', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
          });
        }
      })
      .catch((res) => {
        console.log("error");
      });
  };

  useMemo(() => {
    const getExactDateRateObject = (objectsArray) => {
      /** use these following code to test the function by adding number of year to current years.
       *  Don't forget to commt the currentDate line. */

      // let fakeDate = new Date();
      // fakeDate.setFullYear((new Date()).getFullYear() + 10);
      // console.log("Fake Current Testing date: ",fakeDate);
      // const currentDate = fakeDate;
      //--------------------------------------------------------------------

      // Comment the following line to test with fake curent Date.
      const currentDate = new Date();
      let smallerObject = null;
      let exactObject = null;
      let greaterObject = null;

      objectsArray.forEach(obj => {
        const startDate = new Date(obj.start_date)
        const endDate = new Date(obj.end_date)

        if (currentDate < startDate && (!smallerObject || startDate < new Date(smallerObject.start_date))) {
          smallerObject = obj;
        } else if (currentDate >= startDate && currentDate <= endDate) {
          if (!exactObject || startDate >= new Date(exactObject.startDate)) {
            exactObject = obj;
          }
        } else if (currentDate > endDate && (!greaterObject || endDate > new Date(greaterObject.end_date))) {
          greaterObject = obj;
        }

      })

      if (exactObject) {
        return exactObject;
      } else if (smallerObject) {
        return smallerObject
      } else if (greaterObject) {
        return greaterObject
      } else {
        return null;
      }
    }
    let object = getExactDateRateObject(arry)
    setExactObject(object);

  }, [arry])


  return (
    <>
      <WarningPopup deleteData={deleteDoc} />
      <PathName />
      <div className="d-flex justify-content-between align-items-center px-3 pt-2"></div>{" "}
      <button
        className="d-flex align-items-center border-0 ms-3 bg-transparent"
        onClick={() => navigate(-1)}
      >
        <i className="bx bx-arrow-back fs-2 title-font-600 px-2 bx-fade-left"></i>
        <span className="fs-3 base-font-600">Back</span>{" "}
      </button>
      <div className="bg-white d-flex mb-5 mt-5 flex-column border-radius-32">
        <div className="d-flex flex-column justify-content-center align-items-center align-items-md-center  align-items-lg-center align-items-xl-center align-items-sm-center bg-base-color p-3 p-sm-4 p-md-5 p-lg-5 p-xl-5 border-radius-32-top">
          <h1 className="title-font-600 text-base-white">
            {galatenant?.proposal?.name_of_company}
          </h1>
          <p className="base-font-600 fs-3 text-base-white w-75 text-center ">
            {galatenant?.proposal?.register_address},{" "}
            {galatenant?.project?.address2},Near by{" "}
            {galatenant?.project?.near_by} ,{" "}
            {galatenant?.project?.city?.city_name}{" "}
            {galatenant?.project?.pincode}
          </p>
        </div>
        <div className="card w-100 border-0 rounded-5">
          <div className="row border-bottom p-3 p-sm-3 p-md-5 p-lg-5 p-xl-5">
            <div className=" col-md-4 col-sm-3">
              <div className="card-body">
                <h5 className="fs-3 base-font-700 mb-4">
                  Company Name :{" "}
                  <span className="fs-3 base-font-400">
                    {galatenant?.proposal?.name_of_company}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Building :{" "}
                  <span className="fs-3 base-font-400">
                    {galatenant?.building?.building_no}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Rented Area :{" "}
                  <span className="fs-3 base-font-400">
                    {galatenant?.proposal?.required_area} sq.ft
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Broker Name :{" "}
                  <span className="fs-3 base-font-400">
                    {galatenant?.broker_name === 'null' ? "NA" : galatenant?.broker_name}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Rent Per Sq.Ft :{" "}
                  <span className="fs-3 base-font-400">
                    {<PriceFormater price={exactObject?.rent} />}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Total Monthly Rent :{" "}
                  <span className="fs-3 base-font-400">
                    {
                      <PriceFormater
                        price={
                          exactObject?.rent *
                          Number(galatenant?.proposal?.required_area)
                        }
                      />
                    }
                  </span>{" "}
                </h5>
              </div>
            </div>
            <div className=" col-sm-3  col-md-4">
              <div className="card-body">
                <h5 className="fs-3 base-font-700 mb-4">
                  GST No :{" "}
                  <span className="fs-3 base-font-400">
                    {galatenant?.proposal?.gst_no}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  PAN No :{" "}
                  <span className="fs-3 base-font-400">
                    {galatenant?.proposal?.pan_no}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Possession Date :{" "}
                  <span className="fs-3 base-font-400">
                    {moment(galatenant?.possession_date).format("DD/MM/YYYY")}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Rent Free Period :{" "}
                  <span className="fs-3 base-font-400">
                    {galatenant?.rent_free_period}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Total Monthly Varai :{" "}
                  <span className="fs-3 base-font-400">
                    {
                      <PriceFormater
                        price={
                          Number(galatenant?.proposal?.varai) *
                          Number(galatenant?.proposal?.required_area)
                        }
                      />
                    }
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Total Monthly Maintenance :{" "}
                  <span className="fs-3 base-font-400">
                    {
                      <PriceFormater
                        price={
                          Number(galatenant?.proposal?.maintenance) *
                          Number(galatenant?.proposal?.required_area)
                        }
                      />
                    }
                  </span>{" "}
                </h5>
                {galatenant?.status != "Occupied" && (
                  <h5 className="fs-3 base-font-700 mb-4">
                    Terminated Status :{" "}
                    <span className="fs-3 base-font-400">
                      {galatenant?.status}
                    </span>{" "}
                  </h5>
                )}
              </div>
            </div>
            <div className=" col-md-4 col-sm-4">
              <div className="card-body">
                <h5 className="fs-3 base-font-700 mb-4">
                  Date Start as per Agrmt :{" "}
                  <span className="fs-3 base-font-400">
                    {moment(galatenant?.aggrement_start_date).format(
                      "DD/MM/YYYY"
                    )}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Date End as per Agrmt :{" "}
                  <span className="fs-3 base-font-400">
                    {moment(galatenant?.aggrement_end_date).format(
                      "DD/MM/YYYY"
                    )}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Rent Start From:{" "}
                  <span className="fs-3 base-font-400">
                    {moment(galatenant?.rent_start_date).format("DD/MM/YYYY")}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Rent End Date:{" "}
                  <span className="fs-3 base-font-400">
                    {moment(galatenant?.rent_end_date).format("DD/MM/YYYY")}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Rent Start to Owner :{" "}
                  <span className="fs-3 base-font-400">
                    {moment(galatenant?.rent_actual_start_date).format(
                      "DD/MM/YYYY"
                    )}
                  </span>{" "}
                </h5>
                <h5 className="fs-3 base-font-700 mb-4">
                  Rent End to Owner :{" "}
                  <span className="fs-3 base-font-400">
                    {moment(galatenant?.rent_actual_end_date).format(
                      "DD/MM/YYYY"
                    )}
                  </span>{" "}
                </h5>
                {galatenant?.terminate_date != null && (
                  <h5 className="fs-3 base-font-700 mb-4">
                    Terminated Date :{" "}
                    <span className="fs-3 base-font-400">
                      {" "}
                      {moment(galatenant?.terminate_date).format("DD/MM/YYYY")}
                    </span>{" "}
                  </h5>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {sortGala?.length != 0 && (
        <div className="bg-white p-5 d-flex flex-column rounded-5 mb-5">
          <BuildingExcelTable
            columns={columnnn}
            data={sortGala}
            title={"Investors Gala"}
          />
        </div>
      )}
      {pocData?.length != 0 && (
        <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="mb-5 title-font-bold ">POC</h1>
          </div>
          <Table columns={columns} data={pocData} />
        </div>
      )}
      (
      <div className="bg-white p-5 d-flex gap-5 flex-column rounded-5 mb-5">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <h1 className="title-font-bold ">
            Uploaded Documents ({tenantdoc?.length != 0 && tenantdoc != undefined ? tenantdoc?.length : "0"})
          </h1>
          <Button
            onClick={() => setTogUploadedDocs(!togUploadedDocs)}
            className="fs-3 py-3 px-5  bg-base-color text-base-white border-0 btn btn-secondary shadow-none"
          >
            {togUploadedDocs ? "Hide" : "Show"}
          </Button>
        </div>
        {togUploadedDocs &&
          (tenantdoc?.length != 0 && tenantdoc != undefined ? (
            <DocumentsCard
              documentDetails={tenantdoc}
              tenant={true}
              handle={deleteDocument}
            />
          ) : (
            <EmptyDoc tenant={true} />
          ))}
      </div>
      )
      <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <h1 className="mb-5 title-font-bold ">Annual Rent</h1>
          <Button
            onClick={() => setAnnualRentTableToggle(!annualRentTableToggle)}
            className="fs-3 py-3 px-5  bg-base-color text-base-white border-0 btn btn-secondary shadow-none"
          >
            {annualRentTableToggle ? "Hide" : "Show"}
          </Button>
        </div>
        {annualRentTableToggle &&
          <><Table columns={colums} data={arry} />
            <Table columns={maintenanceVaraiColumn} data={arry} />
            <Table columns={extraOtherColumn} data={arry} />
          </>}
      </div>
    </>
  );
}

export default TenantGalasView;
